import { SelectCard } from "components/InputCards/SelectCard";
import { SelectColorCard } from "components/InputCards/SelectColorCard";
import React, { useCallback, useMemo } from "react";

export const ConfiguratorSelect = ({
  option,
  onChange,
  partKey,
  disabled,
  value,
  handlePartClick,
  isModalView,
}) => {
  const isRalPicker = typeof value === "string" && value.startsWith("RAL");

  const options = useMemo(() => {
    let shouldBeReversed = true;

    const result = option.signatures
      .filter((sig) => sig.state < 2)
      .map((sig) => {
        const isRal = sig.key.split(" ").includes("RAL");
        const affix = sig.value !== sig.title ? ` (${sig.presentation})` : "";
        if (!isRal) {
          shouldBeReversed = false;
        }
        return {
          label: isRal ? `${affix} ${sig.title}` : `${sig.title} ${affix}`,
          value: sig.key,
          description: sig.description,
          state: sig.state,
          isDisabled: sig.state !== 0,
        };
      });

    return shouldBeReversed ? result.reverse() : result;
  }, [option.signatures]);

  const selectedOption = useMemo(
    () => options.find((opt) => opt.value === value),
    [options, value],
  );

  const handleOptionSelect = useCallback(
    (justSelectedOption) => {
      onChange({
        changeData: {
          data: justSelectedOption.value,
          partKey,
          optionKey: option.key,
        },
        changeInput: {},
      });
    },
    [onChange, option.key, partKey],
  );

  return isRalPicker ? (
    <SelectColorCard
      label={option.title}
      options={options}
      partKey={partKey}
      optionKey={option.key}
      description={option.description}
      disabled={disabled}
      handleChange={handleOptionSelect}
      value={selectedOption}
      handlePartClick={handlePartClick}
    />
  ) : (
    <SelectCard
      label={option.title}
      options={options}
      partKey={partKey}
      optionKey={option.key}
      description={option.description}
      disabled={disabled}
      handleChange={handleOptionSelect}
      value={selectedOption}
      handlePartClick={handlePartClick}
      menuPlacement={isModalView ? "bottom" : "auto"}
    />
  );
};
